import { Input } from "@/components/ui/input";
import { DataBr } from "@/components/ui/data-br";
import { Label } from "@/components/ui/label";
import { PERIOD_OPTIONS, type PeriodKey, type PeriodState } from "@/lib/period-filter";

// Mesmo seletor de período nas duas telas que exportam relatório (Pedidos e
// Financeiro). Antes cada uma tinha a sua lista de opções e nenhuma oferecia
// início + fim.
export function PeriodFilter({
  state,
  onChange,
  testId,
}: {
  state: PeriodState;
  onChange: (next: PeriodState) => void;
  testId?: string;
}) {
  const set = (patch: Partial<PeriodState>) => onChange({ ...state, ...patch });

  return (
    <>
      <div className="space-y-1.5 flex-1 min-w-[150px]">
        <Label className="text-xs">Período</Label>
        <select
          className="w-full border rounded-md p-2 text-sm bg-background h-10"
          value={state.period}
          onChange={(e) => set({ period: e.target.value as PeriodKey })}
          data-testid={testId}
        >
          {PERIOD_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>

      {state.period === "mes_escolhido" && (
        <div className="space-y-1.5 flex-1 min-w-[140px]">
          <Label className="text-xs">Mês</Label>
          <DataBr
            tipo="month"
            value={state.pickedMonth}
            onChange={(v) => set({ pickedMonth: v })}
            className="h-10"
            data-testid={testId ? `${testId}-mes` : undefined}
          />
        </div>
      )}

      {state.period === "personalizado" && (
        <>
          <div className="space-y-1.5 flex-1 min-w-[140px]">
            <Label className="text-xs">Início</Label>
            <DataBr
              value={state.customFrom}
              // Preenche o fim junto na primeira escolha: intervalo de um dia é
              // o caso mais comum, e evita a tela ficar num estado sem fim.
              onChange={(v) => set({ customFrom: v, customTo: state.customTo || v })}
              className="h-10"
              data-testid={testId ? `${testId}-inicio` : undefined}
            />
          </div>
          <div className="space-y-1.5 flex-1 min-w-[140px]">
            <Label className="text-xs">Fim</Label>
            <DataBr
              value={state.customTo}
              min={state.customFrom || undefined}
              onChange={(v) => set({ customTo: v })}
              className="h-10"
              data-testid={testId ? `${testId}-fim` : undefined}
            />
          </div>
        </>
      )}
    </>
  );
}
